import { render, staticRenderFns } from "./LazerCultura.vue?vue&type=template&id=58679c2c"
import script from "./LazerCultura.vue?vue&type=script&lang=js"
export * from "./LazerCultura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports